module.exports = __webpack_public_path__ + "static/media/n_icon_strategy@2x.01954881.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/n_icon_strategy@2x.png
// module id = 1814
// module chunks = 0 1